import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "OpinionService",
  controller: "OpinionProject",
};

const methods = [
  "GetProjects",
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
    Fun.prototype[path] = function (data) {
      return this.post(path, data);
    };
  });
};

const OpinionProjectApi = ZJApi.defineNewApi("OpinionProjectApi", factory);

export default OpinionProjectApi;
